module.exports = __webpack_public_path__ + "static/media/YF88_1.8b5d7edf.jpg";